import { z } from "zod";
import { BaseStatisticsInputSchema } from "@/Schemas/Statistics/BaseStatisticsInput";

export const StatisticsSourceInputSchema = BaseStatisticsInputSchema.extend({
    stateTypes: z.array(z.number()),
});

export type StatisticsSourceInput = z.infer<typeof StatisticsSourceInputSchema>;